import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=49da67b1&"
import script from "./profile.vue?vue&type=script&lang=js&"
export * from "./profile.vue?vue&type=script&lang=js&"
import style0 from "./profile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPageContainer,QCard,QTabs,QTab,QCardSection,QTabPanels,QTabPanel,QIcon,QBtn,QDialog,QSpace,QSeparator,QInput,QCardActions,QTimeline,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPageContainer,QCard,QTabs,QTab,QCardSection,QTabPanels,QTabPanel,QIcon,QBtn,QDialog,QSpace,QSeparator,QInput,QCardActions,QTimeline})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
